import { toastSlice } from 'redux/slices/common/toast-slice';

export const { createToast, deleteToast } = toastSlice.actions;
